<template>
    <div class="cost-summary">

        <sidebar-get-in-touch :heading="sidebarsHeading" :description="sidebarsDescription" :emailAddress="sidebarsEmailAddress" :phoneNumber="sidebarsPhoneNumber" class="mb-4"/>

        <div class="mb-5">
            <router-link to="/car-comparison" class="button button--charcoal-ghost button--block">
                &lt; Back to Comparison
            </router-link>
        </div>

        <div>
            <h3>Cost Summary</h3>

            <div v-if="loading" class="text-center">
                <LoadingIcon/>
                <p>Calculating...</p>
            </div>

            <div v-else>
              <salsac-quote-breakdown
                :quote="quote"
                :quoteCosts="quoteCosts"
                :averagePencePerMile="averagePencePerMile"
                :totalEstimatedElectricCostPerMonth="totalEstimatedElectricCostPerMonth"
                :driver-profile="driverProfile"
                :type="type"
                :orderSummaryView="true"/>
            </div>

        </div>

            <section class="mb-4">
                <h3>Colleague Declarations</h3>
                <h4>I confirm that:</h4>
                <div class="checkbox">
                    <input type="checkbox" name="employee-details" id="employee-details" class="employee-details"
                           v-model="confirmations.employeeDetails" disabled>
                    <label for="employee-details" class="multiple-lines">These are my colleague details</label>
                </div>

                <div class="checkbox">
                    <input type="checkbox" name="vehicle-and-vehicle-options" id="vehicle-and-vehicle-options"
                           class="vehicle-and-vehicle-options" v-model="confirmations.correctVehicle" disabled>
                    <label for="vehicle-and-vehicle-options" class="multiple-lines">I have selected the correct
                        vehicle<br/> and vehicle options</label>
                </div>

                <template v-if="(currentProduct.type == 'salsac')">
                    <div class="checkbox">
                        <input type="checkbox" name="salary-sacrifice-hire-arrangement"
                               id="salary-sacrifice-hire-arrangement" class="salary-sacrifice-hire-arrangement"
                               v-model="confirmations.schemeCostDetails" disabled>
                        <label for="personal-contract-hire-arrangement" class="multiple-lines">I have accepted the contract
                            term, mileage and monthly vehicle payment</label>
                    </div>
                </template>

                <template v-if="(currentProduct.type == 'ecoamaps')">
                    <div class="checkbox">
                        <input type="checkbox" name="personal-contract-hire-arrangement"
                               id="personal-contract-hire-arrangement" class="personal-contract-hire-arrangement"
                               v-model="confirmations.creditSaleDetails" disabled>
                        <label for="personal-contract-hire-arrangement" class="multiple-lines">I have accepted the contract
                            term, mileage and monthly vehicle payment</label>
                    </div>

                    <div class="checkbox">
                        <input type="checkbox" name="further-salary-deductions" id="further-salary-deductions"
                               class="further-salary-deductions" v-model="confirmations.furtherSalaryDeductions" disabled>
                        <label for="further-salary-deductions" class="multiple-lines">I have accepted the value that will be
                            deducted from my salary</label>
                    </div>
                </template>

                <div class="checkbox">
                    <input type="checkbox" name="maintenance-key-points" id="maintenance-key-points"
                           class="maintenance-key-points" v-model="confirmations.fullVehicleMaintenance" disabled>
                    <label for="maintenance-key-points">I have accepted the key maintenance points</label>
                </div>

                <div class="checkbox">
                    <input type="checkbox" name="insurance-key-points" id="insurance-key-points"
                           class="insurance-key-points" v-model="confirmations.motorInsuranceProduct" disabled>
                    <label for="insurance-key-points" class="multiple-lines">I have accepted the key insurance
                        points</label>
                </div>

                <div class="checkbox">
                    <input type="checkbox" name="key-points" id="key-points" class="key-points"
                           v-model="confirmations.schemePolicy" disabled>
                    <label for="key-points">I have accepted the key scheme policy points</label>
                </div>

                <template v-if="currentProduct && confirmations">
                  <div v-for="policy in currentProduct.order_stage_three_policies">
                    <template v-if="policy.declaration_required === '1'">
                      <div class="checkbox">
                        <input type="checkbox" name="maintenance-key-points" id="maintenance-key-points"
                          class="maintenance-key-points" v-model="confirmations[stringToKey(policy.title)]" disabled>
                        <label for="maintenance-key-points">I have accepted the {{ policy.title }} points</label>
                      </div>
                    </template>
                  </div>
                </template>

            </section>

    </div>

</template>

<script>
import LoadingIcon from "../../loading-icon.vue";
import {EventBus} from "../../../event-bus";
import SidebarGetInTouch from "../../sidebar-get-in-touch.vue";
import EcoamapsQuoteBreakdown from "../../car-quote/ecoamaps/quote-breakdown.vue";
import SalsacQuoteBreakdown from "../../car-quote/salsac/quote-breakdown.vue";
import Vehicle from "../../../helpers/vehicle";

export default {
    components: {EcoamapsQuoteBreakdown, SalsacQuoteBreakdown, SidebarGetInTouch, LoadingIcon, EventBus},

    mounted() {
        this.getChargingProfile();
    },

    props: {
        confirmations: null,
        driverProfile: null,
        type: null,
        quote: null,
        quoteCosts: null,
        currentProduct: null,
        adminPortalData: null,
    },

    data() {
        return {
            homeChargingStandardPercentage: 25,
            publicChargingStandardPercentage: 25,
            publicChargingFastPercentage: 25,
            publicChargingFreePercentage: 25,

            annualMileage: 10000,
        }
    },

    methods: {
        stringToKey(string) {
            return string.replace(/\ /g, '_');
        },
        getChargingProfile() {
            this.$http.get('/api/get-charging-profile')
                .then(response => {
                    this.homeChargingStandardPercentage = response.data.data.home_charging_standard_percentage;
                    this.publicChargingStandardPercentage = response.data.data.public_charging_standard_percentage;
                    this.publicChargingFastPercentage = response.data.data.public_charging_fast_percentage;
                    this.publicChargingFreePercentage = response.data.data.public_charging_free_percentage;
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response;

                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        title: "Error",
                        text: response.data.message
                    });

                    this.error = err.message.toString();
                    this.$router.push({ name: response.data.redirect });
                });
        },

        milesPerCalendarMonth() {
            return this.annualMileage / 12;
        },
    },

    computed: {
        batterySizeKwh() {
            return Vehicle.getBatterySizeFromDerivative(this.quote.derivative);
        },

        wLTPRangeMiles() {
            return Vehicle.getBatteryRangeFromDerivative(this.quote.derivative);
        },

        loading() {
            if (this.currentProduct.type === 'salsac') {
                return !this.quote || !this.quoteCosts || !this.driverProfile;
            } else {
                return !this.quote || !this.quote.taxCalculations || !this.driverProfile;
            }
        },

        sidebarsDescription() {
            return this.currentProduct ? this.currentProduct.sidebars_description : '';
        },

        sidebarsEmailAddress() {
            return this.currentProduct ? this.currentProduct.sidebars_email_address : '';
        },

        sidebarsHeading() {
            return this.currentProduct ? this.currentProduct.sidebars_heading : '';
        },

        sidebarsPhoneNumber() {
            return this.currentProduct ? this.currentProduct.sidebars_phone_number : '';
        },

        milesPerKWh() {
            return Number(this.wLTPRangeMiles / this.batterySizeKWh).toFixed(2);
        },

        totalMonthlyCost() {
            const milesPerCalendarMonth = this.milesPerCalendarMonth();
            const milesPerKWh = this.wLTPRangeMiles / this.batterySizeKwh

            const homeChargingStandardMonthlyMiles = this.homeChargingStandardPercentage * milesPerCalendarMonth;
            const publicChargingStandardMonthlyMiles = this.publicChargingStandardPercentage * milesPerCalendarMonth
            const publicChargingFastMonthlyMiles = this.publicChargingFastPercentage * milesPerCalendarMonth;
            const publicChargingFreeMonthlyMiles = this.publicChargingFreePercentage * milesPerCalendarMonth;

            const homeChargingStandardTotalKWhForMonthlyMiles = homeChargingStandardMonthlyMiles / milesPerKWh;
            const publicChargingStandardTotalKWhForMonthlyMiles = publicChargingStandardMonthlyMiles / milesPerKWh;
            const publicChargingFastTotalKWhForMonthlyMiles = publicChargingFastMonthlyMiles / milesPerKWh;
            const publicChargingFreeTotalKWhForMonthlyMiles = publicChargingFreeMonthlyMiles / milesPerKWh;
            const homeChargingStandardMonthlyCost = (+this.adminPortalData.content.global.ev_charging_home / 100) * homeChargingStandardTotalKWhForMonthlyMiles;
            const publicChargingStandardMonthlyCost = (+this.adminPortalData.content.global.ev_charging_public_standard / 100) * publicChargingStandardTotalKWhForMonthlyMiles;
            const publicChargingFastMonthlyCost = (+this.adminPortalData.content.global.ev_charging_public_fast / 100) * publicChargingFastTotalKWhForMonthlyMiles;
            const publicChargingFreeMonthlyCost = (+this.adminPortalData.content.global.ev_charging_public_free / 100) * publicChargingFreeTotalKWhForMonthlyMiles;
            const totalMonthlyCost = homeChargingStandardMonthlyCost + publicChargingStandardMonthlyCost + publicChargingFastMonthlyCost + publicChargingFreeMonthlyCost;

            return Number(totalMonthlyCost).toFixed(2);
        },

        averagePencePerMile() {
            return Number(this.totalMonthlyCost / this.milesPerCalendarMonth()).toFixed(2);
        },

        totalEstimatedElectricCostPerMonth() {
            const milesPerCalendarMonth = this.milesPerCalendarMonth();
            const ppm = this.totalMonthlyCost / milesPerCalendarMonth;

            return Number((ppm * milesPerCalendarMonth) / 100).toFixed(2);
        },
    }
};
</script>
